export const getRouteParts = (path) => {
    let parts = path.split('/').filter(part => part.length > 0)
    return parts
}

/**
 * Promise based debounced
 * @param {number} delay Debounce delay in seconds
 * @param {string} key Group debounces
 */
let debounceStack = []
export const debounce = (delay, key = 'global') => {
    return new Promise(resolve => {
        clearTimeout(debounceStack[key])
        debounceStack[key] = setTimeout(resolve, delay)
    })
}

/**
 * Turn a hashed string into a RGB color
 * @param {string} input String to turn into a color
 */
export const stringToColor = (input) => {
    let hash = 0
    if (input.length === 0) return hash
    for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash)
        hash = hash & hash
    }
    let rgb = [0, 0, 0]
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 255
        rgb[i] = value
    }
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
}

/**
 * Turn a hashed string into a RGB color
 * @param {string} input String to turn into a color
 */
export const stringToRgba = (hex) => {
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',0.8)';
    }
    throw new Error('Bad Hex');
}

/**
 * Strips all HTML tags from a given string
 * @param {string} html The html string to process
 */
export const stripTags = (html) => {
    return html.replace(/(<([^>]+)>)/ig,"")
}

export default {
    getRouteParts,
    debounce,
    stringToColor,
    stripTags,
}